export const trainings_actionType = {
    GET_TRAININGS_SUCCESS: 'GET_TRAININGS_SUCCESS',
    GET_TRAININGS_FAILURE: 'GET_TRAININGS_FAILURE',
    EDIT_TRAININGS_REQUEST_SUCCESS: 'EDIT_TRAININGS_REQUEST_SUCCESS',
    EDIT_TRAININGS_REQUEST_FAILURE: 'EDIT_TRAININGS_REQUEST_FAILURE',
    EDIT_REQUEST_START: 'EDIT_REQUEST_START',
    GET_TRAININGS_START: 'GET_TRAININGS_START'
};